import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {HtmlTemplateVar} from '../../dto/templates/html-template-var';
import {EmailTemplate, OrderEmailTemplate} from '../../dto/templates/email-template';
import {HttpClient} from '@angular/common/http';
import {TemplateSendPreviewModel} from '../../models/template-send-preview-model';
import {TemplateSendPreviewResult} from '../../models/template-send-preview-result';
import {EmailTemplatesServiceInterface} from './email-templates-service.interface';

@Injectable({
  providedIn: 'root'
})
export class OrderEmailTemplatesService implements EmailTemplatesServiceInterface {

  readonly apiPath = 'order-email-templates/';
  constructor(
      private http: HttpClient,
  ) {
   }

  getMany(): Observable<DataListModel<OrderEmailTemplate>> {
    return this.http.get(this.apiPath) as Observable<DataListModel<OrderEmailTemplate>>;
  }

  get(id: number): Observable<OrderEmailTemplate> {
    return this.http.get(this.apiPath + id) as Observable<OrderEmailTemplate>;
  }

  getVars(): Observable<DataListModel<HtmlTemplateVar>> {
    return this.http.get(this.apiPath + 'vars') as Observable<DataListModel<HtmlTemplateVar>>;
  }

  getVarsNewsletter(): Observable<DataListModel<HtmlTemplateVar>> {
    return this.http.get(this.apiPath + 'vars-newsletter') as Observable<DataListModel<HtmlTemplateVar>>;
  }

  add(item: EmailTemplate): Observable<number> {
    return this.http.post(this.apiPath, item) as Observable<number>;
  }

  update(id: number, item: EmailTemplate): Observable<Object> {
      return this.http.put(this.apiPath + id, item);
  }

  delete(id: number): Observable<Object> {
    return this.http.delete(this.apiPath + id);
  }

  restore(id: number): Observable<Object> {
    return this.http.patch(this.apiPath + id, null);
  }

  deleteMany(list: number[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  restoreMany(list: number[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  sendPreviewEmail(model: TemplateSendPreviewModel) {
    return this.http.post(this.apiPath + 'send-preview', model) as Observable<TemplateSendPreviewResult>;
  }

  copy(id: number): Observable<number> {
    return this.http.post(this.apiPath + id + '/copy', {oh:1}) as Observable<number>;
  }

}
